import { Theme } from '@mui/material';
import { min } from 'moment';
/**
 * CcfCustomerCard - used to display quick replies component
 * @param props -?-customerCardDetailsStyles
 * @example <customerCardDetailsStyles />
 */
const ConversationsAccordionStyles = (theme: Theme) => {
  const simStyles = {
    accordionContainer: {
      boxShadow: 'none',
      display: 'block',
    },

    accordionHeader: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      minHeight: '30px !important',
      '&$expanded': {
        flexDirection: 'row-reverse',
        paddingLeft: '10px',
        borderTop: `solid ${theme.palette.background.default} 1px`,
        boxShadow: '0px -1px 1px #e7eaec',
        margin: '10px 0px',
      },
      '.MuiAccordionSummary-content': {
        margin: '0px !important',
        '&$expanded': {
          margin: '0px !important',
        },
      },
    },
    accordionHeaderActivityExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: `-1px 1px 1px #fdeeef`,
    },
    accordionDetailsRoot: {
      display: 'flex',
      padding: '8px 16px 16px',
    },

    accordionTitleBlock: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    accordionTitleSubBlock: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '10px',
    },

    accordionTitle: {
      fontFamily: 'Open Sans',
      fontSize: '12px',
      fontWeight: '700',
      lineHeight: '16px',
      color: '#767676',
      textAlign: 'left',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
      textTransform: 'uppercase',
    },

    expandedIcon: {
      height: '18px',
      width: '20px',
      color: `#5B7C8C`,
    },

    hideAccordion: {
      display: 'none',
    },
    mergeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
    },

    notesAccordionTitle: {
      fontWeight: '600',
    },
    simLabelStyles: {
      marginLeft: '5px',
      marginRight: '5px',
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '16px',
    },
  };
  return simStyles;
};
export default ConversationsAccordionStyles;
